export function parse(str: string) {
  if (!str || !str.length) return '';

  let updatedString = str.replace(/\[\[bold\]\]/gm, '<b>').replace(/\[\[\/bold\]\]/gm, '</b>');
  updatedString = updatedString.replace(/\[\[underline\]\]/gm, '<u>').replace(/\[\[\/underline\]\]/gm, '</u>');
  updatedString = updatedString.replace(/\[\[italic\]\]/gm, '<i>').replace(/\[\[\/italic\]\]/gm, '</i>');
  updatedString = updatedString.replace(/\[\[list\]\]/gm, '<ul>').replace(/\[\[\/list\]\]/gm, '</ul>');
  updatedString = updatedString.replace(/\[\[point\]\]/gm, '<li>').replace(/\[\[\/point\]\]/gm, '</li>');
  updatedString = updatedString.replace(/\[\[newline\]\]/gm, '<br>');
  // taken from paragraph control and getTooltip in application.component.ts (QUA-1125)
  updatedString = updatedString.replace(
    /\[\[info\]\]/gm,
    '<span style="display:inline-flex; align-items:center; justify-content:center; background-color:#1976d2; color:white; border-radius:50%; width:18px; height:18px; font-size:12px; font-weight:bold; margin-right:4px; vertical-align:text-bottom;">i</span>'
  );

  // link tags
  // ex: [[link: https://www.qualitybidders.com]]QualityBidders[[/link]]

  // first set up the middle, adding end quote and >
  const regex = /\[\[link:.*?(\]\])/gm;
  let matchArray = regex.exec(updatedString);

  while (matchArray !== null) {
    updatedString = updatedString.substring(0, regex.lastIndex - 2) + "'>" + updatedString.substring(regex.lastIndex);
    matchArray = regex.exec(updatedString);
  }
  // now updatedString = [[link: https://www.qualitybidders.com'>QualityBidders[[/link]]

  updatedString = updatedString
    // now set up the start underline and anchor with href
    .replace(/\[\[link: /gm, '<u><a target="_blank" href=\'')
    // now updatedString = <u><a target="_blank" href='https://www.qualitybidders.com'>QualityBidders[[/link]]

    // now set up the end anchor and underline
    .replace(/\[\[\/link\]\]/gm, '<a/></u>');
  // now updateString = <u><a target="_blank" href='https://www.qualitybidders.com'>QualityBidders</a></u>
  return updatedString;
}
